var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgCustomize = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "_15_Chat",
      "data-name": "15 Chat",
      width: 23.878,
      height: 20.095,
      viewBox: "0 0 23.878 20.095",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22189",
      "data-name": "Path 22189",
      d: "M12.712,117.892H1.166a1.166,1.166,0,1,1,0-2.332H12.713a1.166,1.166,0,1,1,0,2.332Z",
      transform: "translate(0 -112.019)"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22190",
      "data-name": "Path 22190",
      d: "M403.5,117.892h-2.919a1.166,1.166,0,0,1,0-2.332H403.5a1.166,1.166,0,1,1,0,2.332Z",
      transform: "translate(-380.792 -112.019)"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22191",
      "data-name": "Path 22191",
      d: "M227.142,348.772H215.6a1.166,1.166,0,1,1,0-2.332h11.546a1.166,1.166,0,1,1,0,2.332Z",
      transform: "translate(-204.43 -332.131)"
    })), _ref5 || (_ref5 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22192",
      "data-name": "Path 22192",
      d: "M4.084,348.772H1.166a1.166,1.166,0,1,1,0-2.332H4.084a1.166,1.166,0,1,1,0,2.332Z",
      transform: "translate(0 -332.131)"
    })), _ref6 || (_ref6 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22193",
      "data-name": "Path 22193",
      d: "M67.277,278.074a4.707,4.707,0,1,1,4.707-4.707A4.707,4.707,0,0,1,67.277,278.074Zm0-7.082a2.375,2.375,0,1,0,2.375,2.375A2.375,2.375,0,0,0,67.277,270.992Z",
      transform: "translate(-59.652 -257.979)"
    })), _ref7 || (_ref7 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22194",
      "data-name": "Path 22194",
      d: "M252.267,49.044a4.707,4.707,0,1,1,4.707-4.707A4.707,4.707,0,0,1,252.267,49.044Zm0-7.082a2.375,2.375,0,1,0,2.375,2.375A2.375,2.375,0,0,0,252.267,41.962Z",
      transform: "translate(-236.015 -39.63)"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgCustomize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Customize.4027f197.svg";
export { ForwardRef as ReactComponent };